import { useQuery } from "@tanstack/react-query";

import { useEnvironment } from "@/common/contexts/EnvironmentContext";
import api from "@/common/utils/api";
import { featureQueryKeys } from "@/feature/data/featureQueryKeys";

export function useFeatureOptInMembershipsData(featureId?: string) {
  const { app, env } = useEnvironment();

  return useQuery({
    queryKey: featureQueryKeys.optInMemberships(app.id, env.id, featureId),
    queryFn: () =>
      api
        .get<"/apps/:appId/features/:featureId/opt-in-memberships">(
          `/apps/${app.id}/features/${featureId}/opt-in-memberships`,
          { params: { envId: env.id } },
        )
        .then((res) => res.data),
    enabled: !!featureId,
  });
}
